import React from 'react';
import ReactDOM from 'react-dom';

// Portalled for the same reason as ErrorPopup: a fixed overlay mounted inside a
// transformed ancestor centres on that ancestor, not the viewport.
const SuccessPopup = ({onClose,message}) => {
  return ReactDOM.createPortal(
    <div className="popup" onClick={onClose}>
    <div className="popup-content" onClick={(e) => e.stopPropagation()}>
      <div className="text-end">
      <button  className="bg-transparent border-0" onClick={onClose}><i className="bi bi-x-circle"></i></button>
      </div>
      <div className="text-center mt-2">
        <p className="mb-0 text-success ev-fs-30"><i className="bi bi-check2-circle"></i></p>
        <p className="ev-fs-12 ev-bold-reg">{message}</p>
      </div>
    </div>
  </div>,
    document.body
  );
};

export default SuccessPopup;
